import { FlightClass } from 'src/app/models/DealsModels'; 

const SKYSCANNER_BASE_URL = 'https://www.skyscanner.net/g/referrals/v1/flights/day-view';
const market = 'US';
const locale = 'en-US';
const currency = 'USD';

export function generateSkyscannerUrl(
  originCode: string,
  destinationCode: string,
  departureDate: string, 
  returnDate: string,    
  flightClass: FlightClass,
): string {

  const airportFromTo = `origin=${originCode}&destination=${destinationCode}`;
  const dates = `outboundDate=${departureDate}&inboundDate=${returnDate}`;
  const seatingClass =
    flightClass === FlightClass.Business ? 'cabinclass=business&' : 'cabinclass=economy&'; 
  
  const localParams = `&market=${market}&locale=${locale}&currency=${currency}`
  const otherParams =
    `?${seatingClass}${airportFromTo}&${dates}` +
    `&adults=1&adultsv2=1&rtn=1&children=0&childrenv2=&infants=0` +
    `&qp_prevCurrency=USD&qp_prevProvider=DS_RDS_Standard` +
    `&adId=1100662&campaignId=13416&mediaPartnerId=2871437`;

  return `${SKYSCANNER_BASE_URL}${otherParams}${localParams}`;
}